import { sizeFormat } from "../../../utils/fileHelpers";
import TileItemInfo from "../../molecules/TileItemInfo/TileItemInfo";
import TileItemImgInfo from "../../molecules/TileItemImgInfo/TileItemImgInfo";
import TileItem from "../TileItem/TileItem";
import { languages } from "../../../dummyData/dummyData";
import { filesRepository } from "../../../repository/files.repository";
import { ACTIONS, PopupsContext } from "../../../contexts/PopupsContext";
import { useContext } from "react";
import { dateFormat } from "../../../utils/formatters";

const FileTile = ({ data }) => {
  const { id, selectableId, fileImg, name, description, category, target_name, filesize, visibility, visibilityImg, created, extension, isChecked } = data;
  const { callPopup } = useContext(PopupsContext);

  return (
    <TileItem title={name} image={fileImg} selectableId={id} isChecked={isChecked} imageFit={false} buttons={[
      {
        icon: "garbage",
        onClick: () => callPopup({
          type: ACTIONS.DELETE,
          payload: {
            type: languages.EN.labels.file,
            elementName: name,
            action: () => filesRepository.deleteFile(id),
          },
        }),
        tooltip: languages.EN.labels.delete,
      },
      {
        icon: "download",
        onClick: () => filesRepository.downloadFile(id, name, extension),
        tooltip: languages.EN.labels.download,
      },
      // { icon: "edit", onClick: () => callPopup({
      //     type: ACTIONS.FORM,
      //     payload: {
      //       header: `${languages.EN.labels.edit} ${languages.EN.labels.file}`,
      //       fields: popupFields(data),
      //       postAction: filesRepository.postFile,
      //     },
      //   }),
      // },
    ]}>
      <TileItemInfo header={languages.EN.labels.description} value={description} />
      <TileItemInfo header={languages.EN.labels.category} value={languages.EN.enums.fileCategories[category]} />
      <TileItemInfo header={languages.EN.labels.linkedElementName} value={target_name} />
      <TileItemInfo header={languages.EN.labels.size} value={sizeFormat(filesize)} />
      <TileItemInfo header={languages.EN.labels.added} value={dateFormat(created)} />
      <TileItemImgInfo header={languages.EN.labels.visibility} value={visibility} image={visibilityImg} />
    </TileItem>
  );
};

export default FileTile;
